import React from "react";

const LogoutButton = ({ logout }: { logout: () => void }) => (
  <button
    onClick={logout}
    className="w-full h-10 px-4 bg-[#1980e6] text-white text-sm font-bold rounded-xl"
  >
    Logout
  </button>
);

export default LogoutButton;
